<div class="container-fluid margin-top-10">
    <simple-grid #pendingMachines [settings]=grid></simple-grid>
</div>